import { Constants } from '../config/constants.config';
import { formatDate } from '../utilities/date.utilities';
var DateService = /** @class */ (function () {
    function DateService(constants) {
        this.constants = constants;
    }
    DateService.prototype.getDate = function (date) {
        if (date === void 0) { date = new Date(); }
        return formatDate(date, this.constants.defaultAPIDateFormat);
    };
    DateService.prototype.dayForwards = function (date) {
        return new Date(date.getTime() + this.dayTimestamp);
    };
    DateService.prototype.dayBackwards = function (date) {
        return new Date(date.getTime() - this.dayTimestamp);
    };
    Object.defineProperty(DateService.prototype, "milisecondTimestamp", {
        get: function () {
            // one milisecond = one milisecond
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateService.prototype, "secondTimestamp", {
        get: function () {
            // one second = 1000 miliseconds
            return 1000 * this.milisecondTimestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateService.prototype, "minuteTimestamp", {
        get: function () {
            // one minute = 60 seconds
            return 60 * this.secondTimestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateService.prototype, "hourTimestamp", {
        get: function () {
            // one hour = 60 minutes
            return 60 * this.minuteTimestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateService.prototype, "dayTimestamp", {
        get: function () {
            // one day = 24 hours
            return 24 * this.hourTimestamp;
        },
        enumerable: true,
        configurable: true
    });
    return DateService;
}());
export { DateService };
